/* eslint-disable import/no-cycle */
import React, { useMemo, useCallback } from "react";
import Box from "../Box";
import ClearInputIcon from "@pixel/assets/icons/ClearInput";
import NumberRangeField from "../NumberRangeField";
import { createEmptyAppliedFilter } from '.';
const infinitySymbol = '\u221E';
const VALUECONTEXT_MAX = 'max';
const VALUECONTEXT_MIN = 'min';
const ListFilterNumberRange = /*#__PURE__*/React.forwardRef((_ref2, _ref) => {
  var _appliedFilterValues$, _appliedFilterValues$2, _appliedFilterValues$3, _appliedFilterValues$4;
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref2;
  const {
    minValue = 0,
    maxValue = 100,
    step = 1
  } = searchFilter;
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes
  ]);
  const handleChangeValue = useCallback(newValueRange => {
    if (newValueRange != null) {
      const filterValues = []; //Note: even though its single select we commonize the way we pass back data in an array
      if (newValueRange[0] != null || newValueRange[1] != null) {
        //value could be 0
        const newMinVal = newValueRange[0] != null ? "".concat(newValueRange[0]) : null; //because we only accept strings convert it
        const newMinVal_label = newValueRange[0] != null ? newMinVal : minValue == null ? "-".concat(infinitySymbol) : "".concat(minValue);
        const filterValueMin = {
          value: newMinVal,
          //note: we only pass strings 
          label: newMinVal_label,
          context: VALUECONTEXT_MIN
        };
        const newMaxVal = newValueRange[1] != null ? "".concat(newValueRange[1]) : null; //because we only accept strings convert it
        const newMaxVal_label = newValueRange[1] != null ? newMaxVal : maxValue == null ? "".concat(infinitySymbol) : "".concat(maxValue);
        const filterValueMax = {
          value: newMaxVal,
          //note: we only pass strings 
          label: newMaxVal_label,
          context: VALUECONTEXT_MAX
        };
        const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
        newAppliedSearchFilter.filterValues = [filterValueMin, filterValueMax];
        newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(filterValueMin.label, " - ").concat(filterValueMax.label);
        onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
      } else {
        onChangeAppliedFilter(searchFilter, null);
      }
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  const handleClear = e => {
    onChangeAppliedFilter(searchFilter, null);
  };
  const minval = isNaN(parseInt("".concat((_appliedFilterValues$ = appliedFilterValues[0]) === null || _appliedFilterValues$ === void 0 ? void 0 : _appliedFilterValues$.value))) ? null : parseInt("".concat((_appliedFilterValues$2 = appliedFilterValues[0]) === null || _appliedFilterValues$2 === void 0 ? void 0 : _appliedFilterValues$2.value));
  const maxval = isNaN(parseInt("".concat((_appliedFilterValues$3 = appliedFilterValues[1]) === null || _appliedFilterValues$3 === void 0 ? void 0 : _appliedFilterValues$3.value))) ? null : parseInt("".concat((_appliedFilterValues$4 = appliedFilterValues[1]) === null || _appliedFilterValues$4 === void 0 ? void 0 : _appliedFilterValues$4.value));
  const value = [minval, maxval];

  // console.log('ListFilterNumberRange', {searchFilter, appliedSearchFilter, value, minValue, maxValue, step})

  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(NumberRangeField, {
    id: "".concat(searchFilter.id),
    fullWidth: true,
    onChange: handleChangeValue,
    label: null,
    ariaLabel: searchFilter.label,
    value: value,
    placeholder: searchFilter.placeholder,
    min: minValue,
    max: maxValue,
    labelMin: searchFilter.labelMin,
    labelMax: searchFilter.labelMax,
    step: step,
    endingButtonProps: {
      ariaLabel: "Clear",
      icon: ClearInputIcon,
      onClick: handleClear,
      disabled: true
    }
  }));
});
export default ListFilterNumberRange;